import {
  FUNDING_RATE_DECIMALS,
  useMarketStore,
} from '@/store/use-markets-store';
import { cn } from '@/utils/cn';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';
import { ColumnDef } from '@tanstack/react-table';
import { useStore } from 'zustand';

type Props = {
  symbol: string;
};

export default function FundingRate({ symbol }: Props) {
  const fundingRate = useStore(
    useMarketStore(symbol),
    (state) => state.marketData.oneHrFundingRate * 100n * 8n,
  );
  return (
    <span
      className={cn('text-vestgrey-100', {
        'text-red': fundingRate < 0n,
        'text-green': fundingRate > 0n,
      })}
    >
      {formatBigInt(fundingRate, FUNDING_RATE_DECIMALS, {
        style: 'percent',
        digits: 4,
      })}
    </span>
  );
}

export const fundingRateAccessorFn = (symbol: string) => {
  const { oneHrFundingRate } = useMarketStore(symbol).getState().marketData;
  return bigIntToNum(oneHrFundingRate, FUNDING_RATE_DECIMALS);
};
